<div class="flex gap-2 items-center p-1">
  <div class="flex flex-col justify-center">
    <mat-icon>{{ icon }}</mat-icon>
  </div>

  <span [innerHTML]="message" class="text-white"></span>
</div>

@if (action) {
<div class="p-1 mt-2 flex justify-center items-center">
  <button mat-flat-button (click)="onAction()" [innerHTML]="action.label"></button>
</div>
}
